import {
  DEFAULT_DATE_FORMAT_FNS,
  FilterKeys,
  GetAttendanceRegistersQueryFilters,
} from '@schooly/api';
import { format } from 'date-fns';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

export type UseAttendanceFiltersProps = {
  filters: GetAttendanceRegistersQueryFilters;
  onSetFilters: (filters: GetAttendanceRegistersQueryFilters) => void;
};

export const useAttendanceFilters = ({ filters, onSetFilters }: UseAttendanceFiltersProps) => {
  const { formatMessage } = useIntl();

  const actions = useMemo(() => {
    const onSetDate = (v: [Date, Date]) => {
      const updatedDates = [
        format(v[0], DEFAULT_DATE_FORMAT_FNS),
        format(v[1], DEFAULT_DATE_FORMAT_FNS),
      ];
      onSetFilters({
        ...filters,
        [FilterKeys.Date]: updatedDates,
      });
    };

    return { onSetDate };
  }, [filters, onSetFilters]);

  const filtersDate = filters.date;

  const labels = {
    [FilterKeys.Date]: formatMessage({ id: 'schoolProperty-Period' }),
  };

  return {
    ...actions,
    labels,
    filtersDate,
  };
};
